import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "slider-left",
  "use": "slider-left-usage",
  "viewBox": "0 0 33 34",
  "content": "<symbol viewBox=\"0 0 33 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"slider-left\">\r\n<path d=\"M20.0059 7.71631C20.5371 8.24757 20.5371 9.1089 20.0059 9.64015L12.8056 16.8404L20.0059 24.0406C20.5371 24.5719 20.5371 25.4332 20.0059 25.9645C19.4746 26.4957 18.6133 26.4957 18.082 25.9645L9.91986 17.8023C9.3886 17.2711 9.3886 16.4097 9.91986 15.8785L18.082 7.71631C18.6133 7.18506 19.4746 7.18506 20.0059 7.71631Z\" fill=\"#E2E2E2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol